import React, { useEffect } from 'react';
import { Typography, Card } from 'antd';
import { useAccount } from 'wagmi';
import { useNavigate } from 'react-router-dom';
import ConnectWalletButton from '../components/ConnectWalletButton';
import '../styles/LoginPage.css'; // Add CSS file for styling

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const { isConnected } = useAccount(); // Check wallet connection status
  const navigate = useNavigate(); // Navigate between routes

  useEffect(() => {
    if (isConnected) {
      navigate('/dashboard'); // Redirect to Dashboard if connected
    }
  }, [isConnected, navigate]);

  return (
    <div className="login-page">
      <Card className="login-card">
        <Title level={2} className="login-title">
          Welcome to dSoftGames
        </Title>
        <Text type="secondary" className="login-subtitle">
          Connect your wallet to continue
        </Text>
        <div style={{ marginTop: '1.5rem' }}>
          <ConnectWalletButton />
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
